import React from "react";
import { Navigate, useParams } from "react-router-dom";
import WalletPage from ".";
import SpotWalletPage from "./SpotWalletPage";
import FundingAccountPage from "../FundingAccountPage";
import TradingAccountPage from "../TradingAccountPage";
import MarginAccountPage from "../MarginAccountPage";
import CrossMarginAccountPage from "../CrossMarginAccountPage";
import FuturesAccountPage from "../FuturesAccountPage";
import OptionsAccountPage from "../OptionsAccountPage";

export default function WalletTypeRoute() {
  const { walletType } = useParams();
  const type = String(walletType || "").toLowerCase();
  if (type === "funding") {
    return <FundingAccountPage />;
  }
  if (type === "trading") {
    return <TradingAccountPage />;
  }
  if (type === "margin") {
    return <MarginAccountPage />;
  }
  if (type === "cross_margin") {
    return <CrossMarginAccountPage />;
  }
  if (type === "futures") {
    return <FuturesAccountPage />;
  }
  if (type === "financial") {
    return <Navigate to="/user_profile/wallet/options" replace />;
  }
  if (type === "options") {
    return <OptionsAccountPage />;
  }
  if (type === "staking") {
    return <Navigate to="/user_profile/staking" replace />;
  }
  if (type === "spot") {
    return <SpotWalletPage />;
  }
  return <WalletPage />;
}

